;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import styles from './ReCaptchaLegal.module.scss';

const ReCaptchaLegal = () => {
    return (
        <div className={styles.root}>
            This site is protected by reCAPTCHA and the Google{' '}
            <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noreferrer"
            >
                Privacy Policy
            </a>{' '}
            and{' '}
            <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noreferrer"
            >
                Terms of Service
            </a>{' '}
            apply.
        </div>
    );
};

export default ReCaptchaLegal;
